<template>

  <div
    class="p-5"
    style="max-width: 900px; font-size: 16px;">
    <h1 class="display-4 mb-4">Descubra o Futuro da Aquisição de Talentos com o Rhevolut!</h1>
    <p class="lead">A Rhevolut transforma a forma de conectar vagas a candidatos. Aborde diretamente os candidatos por meio de um match avançado para identificar os talentos ideais.</p>
    <div class="row my-5">
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <h5>Matching Inteligente.</h5>
            <p class="m-0">Algoritmos avançados garantem a compatibilidade perfeita entre candidatos e vagas.</p>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <h5>Engajamento Direto.</h5>
            <p class="m-0">A plataforma permite a abordagem direta de candidatos promissores, agilizando o processo de seleção.</p>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <h5>Interesse Ativo de Candidatos.</h5>
            <p class="m-0">Permite que candidatos qualificados demonstrem interesse nas vagas, assegurando agilidade no processo de atração.</p>
          </div>
        </div>
      </div>
    </div>
    <p>Entre em contato agora e veja como o Rhevolut pode revolucionar sua busca por talentos!</p>
    <p class="lead mt-4">
      <a
        class="btn btn-primary btn-lg"
        href="#"
        role="button">Ver planos</a>
    </p>

  </div>

</template>

<script>
export default {
  name: 'Rhevolut',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Rhevolut/Rhevolut.vue